import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardDialog } from "@/dashboard-design-system/Dialog";

interface ConfirmRateChangeDialogProps {
  open: boolean;
  variant: "price" | "date" | "taxes";
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmRateChangeDialog: FC<ConfirmRateChangeDialogProps> = ({ open, variant, onConfirm, onClose }) => {
  const { t } = useTranslate();

  const title = {
    date: t("dashboard", "ticketing.confirmationModal.modifyByDate.title"),
    price: t("dashboard", "ticketing.confirmationModal.modifyByPrice.title"),
    taxes: t("dashboard", "ticketing.confirmationModal.modifyByTaxes.title"),
  }[variant];

  const content = {
    date: t("dashboard", "ticketing.confirmationModal.modifyByDate.content"),
    price: t("dashboard", "ticketing.confirmationModal.modifyByPrice.content"),
    taxes: t("dashboard", "ticketing.confirmationModal.modifyByTaxes.content"),
  }[variant];

  if (!open) {
    return null;
  }

  return (
    <DashboardDialog
      title={title}
      open={open}
      actions={{
        main: { onClick: onConfirm },
        cancel: { onClick: onClose },
      }}
      onClose={onClose}
      hideIcon
    >
      <span>{content}</span>
    </DashboardDialog>
  );
};
